<template>
  <div id="notifications">
      <div v-for="error in decodedErrors" v-if="displayErrors">
        <div class="alert alert-danger" role="alert">
            <strong v-if="error.label">{{error.label}}: </strong>
            <button class="closed" data-dismiss="alert">
              <!-- <i class="fa fa-times"></i> -->
            </button>
            <ul>
              <li v-for="(em, idx) in error.message" :keys="'error-message-' + idx ">{{em}}</li>
            </ul>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    props: ["error", "fields", "model"],

    computed: {

        errorList () {
            return this.error.errors
        },

        message () {
            return this.error.message
        },

        decodedErrors () {
            const vm = this
            return _.chain(vm.errorList).map((errors, modelPath) => {
                if (modelPath === 'date_incompatibility')
                    return {
                        label: "Dates",
                        invalid: false,
                        required: false,
                        incompatible: true,
                        message:errors
                    }
                const field = _.find(vm.fields, (f) => f.model === modelPath)
                if (field)
                {
                  var error_obj = {
                    label:field.label,
                    message:errors,
                  }
                  return (error_obj)
                }
                return null
            }).filter(f => !_.isNull(f)).value()
        },

        displayErrors () {
            return this.decodedErrors.length
        }

    },
}
</script>

<style scoped>
.closed {
  background-position: -95px -10px !important;
  background: url(/static/media/noti-cross.8b70ae64.png) no-repeat scroll 0 0 transparent;
  float: right;
  width: 10px;
  height: 15px;
  opacity: 0.8;
  border: none;
}
</style>



// WEBPACK FOOTER //
// client/components/Forms/Notifications.vue